import type { User, Privilege } from "@/assets/js/types";
import { deleteLocalStorageReac } from "@/assets/js/helpers";
import api from "@/api";
import router from "@/router";
import { getJwtData } from "@/assets/js/helpers";
import { CompanyStore } from "@/store/companyStore";
import { TransferStore } from "./transferStore";

export const UserStore = defineStore("UserStore", () => {
  const companyStore = CompanyStore();
  const transferStore = TransferStore();

  const user = ref<User | null>(null);
  const navigate = ref<string | null>(null);
  const privileges = ref<Privilege[]>([]);

  const getAllPermissions = computed(() => {
    return privileges.value;
  });

  function setNavigate(path: string | null): void {
    navigate.value = path;
  }

  const getUser = computed(() => {
    return user.value;
  });

  async function logout() {
    try {
      await api.logout();
    } catch (error) {
      console.log(error);
    } finally {
      transferStore.clearClipboard("both");
      deleteLocalStorageReac("jwt");
      router.push({ name: "LoginPage" });
    }
  }

  async function getUserData() {
    const jwt = await getJwtData();

    if (!jwt && router.currentRoute.value.meta.jwtRequired) {
      router.push({ name: "LoginPage" });
    }

    const params = {
      cmp_id: companyStore.getActiveCompany?.cmp_id,
    };
    console.log(params);
    try {
      const res = await api.getUserData(params);
      const userData = res.data.userData;
      const newUser: User = {
        name: userData.name,
        lastName: userData.lastname,
        email: userData.email,
        img_id: userData.img_id,
        usr_displayname: userData.usr_displayname,
        id: userData.usr_id,
        usr_color: userData.usr_color,
        phone: userData.phone === "null" ? null : userData.phone,
        status: userData.status,
      };
      user.value = newUser;
    } catch (error) {
      router.push({ name: "LoginPage" });
    }
  }

  async function fetchPermissions() {
    const cmp_id = companyStore.getActiveCompany?.cmp_id;

    try {
      const params: any = {
        cmp_id: cmp_id,
      };
      const res = await api.fetchPermissions(params);
      privileges.value = res.data.privileges;
    } catch (error) {
      console.log(error);
    }
  }

  const theme = ref(false); // there will probably be a change

  function setTheme() {
    // SET FUNCIONALITY FOR LIGHT THEME... global style is set
    // value = light
    const html = document.getElementsByTagName("html");

    // remove dynamically because it might have more classes and we won't know which one to remove
    const classList: string[] = [];
    for (let i = 0; i < html[0].classList.length; i++) {
      // html[0].classList.remove(html[0].classList[i]);
      classList.push(html[0].classList[i]);
    }
    for (let i = 0; i < classList.length; i++) {
      html[0].classList.remove(classList[i]);
    }

    // set

    /* eslint-disable */
    /* prettier-ignore */
    let theme = localStorage.getItem("theme");
    if (theme) {
      html[0].classList.add(theme); // value = light
    } else {
      html[0].classList.add("dark"); // dark
    }
  }
  return {
    theme,
    setTheme,
    user,
    getUser,
    logout,
    navigate,
    setNavigate,
    getUserData,
    fetchPermissions,
    privileges,
    getAllPermissions,
  };
});
